module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Tu es perdu(e) !")]), _vm._v(" "), _c('h4', [_vm._v("Cette page n'existe pas.")]), _vm._v(" "), _c('h4', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Retour à la "), _c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(".")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af7dc52e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 34
// module chunks = 0